<template>
  <el-drawer v-model="visible" title="添加/编辑企业" size="600px">
    <el-form :model="org" ref="orgForm" :rules="rules" label-width="100px">
      <el-form-item label="企业名称:" prop="fullName">
        <el-input v-model="org.fullName"></el-input>
      </el-form-item>
      <el-form-item label="企业简称:" prop="name">
        <el-input v-model="org.name"></el-input>
      </el-form-item>
      <el-form-item v-if="org.logoPath" label="LOGO:">
        <el-upload
          class="upload-demo"
          accept=".ico,.jpg,.jpeg,.png"
          name="multiFile"
          :show-file-list="false"
          :action="uploadLogoURL"
          :on-success="handleUploadLogoSuccess"
          :on-error="handleUploadLogoError"
          :before-upload="beforeAvatarUploadLogo">
          <el-avatar v-if="org.logoPath" :size="80" :src="org.logoURL" shape="square"></el-avatar>
        </el-upload>
        <span style="display:inline-block;position:absolute;color:red;margin-left:18%;cursor:pointer;" @click.stop="handleRemoveLogo">
          <el-icon :size="20">
            <delete></delete>
          </el-icon>
        </span>
      </el-form-item>
      <el-form-item v-else label="LOGO:">
        <el-upload style="border:1px solid;"
          class="upload-demo"
          accept=".ico,.jpg,.jpeg,.png"
          name="multiFile"
          :show-file-list="false"
          :action="uploadLogoURL"
          :on-success="handleUploadLogoSuccess"
          :on-error="handleUploadLogoError"
          :before-upload="beforeAvatarUploadLogo">
          <el-icon style="font-size:20px;padding:28px;">
            <plus></plus>
          </el-icon>
        </el-upload>
      </el-form-item>
      <el-form-item label="联系人:" prop="contactName">
        <el-input v-model="org.contactName"></el-input>
      </el-form-item>
      <el-form-item label="联系电话:" prop="contactPhone">
        <el-input v-model="org.contactPhone"></el-input>
      </el-form-item>
      <el-form-item label="统一信用代码:">
        <el-input v-model="org.unifiedCreditCode"></el-input>
      </el-form-item>
      <el-form-item label="经营范围:">
        <el-input type="textarea" v-model="org.introduce" :rows="5"></el-input>
      </el-form-item>
      <el-form-item v-if="org.businessLicensePath" label="营业执照:">
        <el-upload style="font-size:20px;"
          v-for="(item,index) in businessLicensePathArray" :key="item"
          class="upload-demo"
          accept=".jpg,.jpeg,.png"
          name="multiFile"
          :show-file-list="true"
          :action="uploadBusiLicenseURL"
          :on-success="(res)=>handleUploadBusinessLicenseSuccess(res,index)"
          :on-error="handleUploadBusinessLicenseError"
          :before-upload="beforeAvatarUploadBusinessLicense"
          :headers="token">
          <el-avatar :size="420" :src="item" shape="square"></el-avatar>
          <span class="busi-license-del" @click.stop="()=>handleRemoveBusinessLicense(index)">
            <el-icon :size="20">
              <delete></delete>
            </el-icon>
          </span>
        </el-upload>
        </el-form-item>
        <el-form-item v-else label="营业执照:">
        <el-upload style="border:1px solid;"
          class="upload-demo"
          accept=".jpg,.jpeg,.png"
          name="multiFile"
          :show-file-list="false"
          :action="uploadBusiLicenseURL"
          :on-success="(res)=>handleUploadBusinessLicenseSuccess(res,null)"
          :on-error="handleUploadBusinessLicenseError"
          :headers="token"
          :before-upload="beforeAvatarUploadBusinessLicense">
          <el-icon style="font-size:20px;padding:28px;">
            <plus></plus>
          </el-icon>
        </el-upload>
      </el-form-item>
    </el-form>

    <template #footer>
      <div>
        <el-button @click="visible = false;" :loading="loading">取消</el-button>
        <el-button type="primary" @click="save" :loading="loading">保存</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { getEnterpriseById, saveOrg } from '@/api/enterprise';
import store from '@/store/index.js';
import { defineComponent } from 'vue';
import { requestPrefix } from '@/utils/common'

const  downloadFileURL = requestPrefix+'/enterpriseWx/downLoadFile',
  uploadLogoURL = requestPrefix+"/ent/uploadLogo",
  uploadBusiLicenseURL = requestPrefix+"/ent/uploadBusiLicense";



export default defineComponent({
  emits: ['get-data'],
  data() {
    return {
      visible: false,
      org: {},
      uploadLogoURL:uploadLogoURL+"?accessToken="+encodeURI(store.getters.accessToken),
      uploadBusiLicenseURL:uploadBusiLicenseURL+"?accessToken="+encodeURI(store.getters.accessToken),
      token:{"accessToken":store.getters.accessToken},
      businessLicensePathArray:[],
      businessLicensePathArrayTwo:[],
      imgFileMimeArray:['image/jpeg','image/x-icon','image/png'],
      rules: {
        name: [
          { required: true, message: '请输入企业简称', trigger: 'blur' }/*,
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }*/
        ],
        fullName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true,validator:(rule, value, callback)=>{//console.log("custom_Rule",value);
            if (!value) {
              callback(new Error('联系人电话不能为空'));
            } else if (!/^1[3-9]\d{9}$/.test(value)) {
              callback(new Error('联系人电话格式不正确!'));
            } else {
              callback();
            }
          }, trigger: 'blur' }
        ],
        /*date2: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],*/
        
      },
      loading: false
    }
  },
  methods: {
    add(parentOrg) {
      this.org = {
        pid: parentOrg.orgId
      };
      this.$refs.orgForm && this.$refs.orgForm.clearValidate();
      this.visible = true;
    },
    edit(orgUnit) {
      this.getOrg(orgUnit.orgId);
    },
    getOrg(id) {
      getEnterpriseById(id).then(({data}) => {
        if (data.data) {
          this.org = data.data;
          if(this.org.logoPath){
            this.org.logoURL=downloadFileURL+"?filePath="+encodeURI(this.org.logoPath)+"&accessToken="+encodeURI(store.getters.accessToken);
          }
          if(this.org.businessLicensePath){
            this.path2Array(this.org.businessLicensePath);
          }
          this.$refs.orgForm && this.$refs.orgForm.clearValidate();
          this.visible = true;
        } else {
          this.$message.error('企业不存在');
        }
      })
    },
    save() {
      this.$refs.orgForm.validate(valid => {
        if (valid) {
          this.loading = true;
          saveOrg(this.org).then(({data}) => {
            if (data.status) {
              this.$message.success(data.msg);
              this.$emit('get-data');
              this.visible = false;
            } else {
              this.$message.warning(data.msg);
            }
          })
          this.loading = false;
        }
      })
    },
    handleRemoveBusinessLicense(index){//console.log("click");
      // e.stopPropagation();
      this.businessLicensePathArrayTwo.splice(index,1);
      this.org.businessLicensePath=this.businessLicensePathArrayTwo.join(',');
      this.path2Array(this.org.businessLicensePath);
    },
    handleRemoveLogo(){//console.log(file);
      this.org.logoPath=null;
      this.org.logoURL=null;
    },
    beforeAvatarUploadBusinessLicense(file){//console.log("before",file);
      if(this.imgFileMimeArray.includes(file.type)){
        return true;
      }else{
        this.$message.warning('只能上传jpg、jpeg、png图片！');
        return false;
      }
    },
    beforeAvatarUploadLogo(file){//console.log(file);
      if(this.imgFileMimeArray.includes(file.type)){
        return true;
      }else {
        this.$message.warning('只能上传ico、jpg、jpeg、png图片！');
        return false;
      }
    },
    handleUploadBusinessLicenseSuccess(res,index){//console.log(res);
      if(null!=index&&undefined!=index&&index>-1){
        if(res&&res.data){
          this.businessLicensePathArrayTwo[index]=res.data;
          this.org.businessLicensePath=this.businessLicensePathArrayTwo.join(',');
          this.businessLicensePathArray[index]=downloadFileURL+"?filePath="+encodeURI(res.data)+"&accessToken="+encodeURI(store.getters.accessToken);
        }else this.$message.warning('上传失败！');
      }else{
        if(this.org.businessLicensePath){
          this.org.businessLicensePath+=','+res.data;
        }else{
          this.org.businessLicensePath=res.data;
        }
        this.path2Array(this.org.businessLicensePath);
      }
    },
    handleUploadBusinessLicenseError(param){//console.log(param);
      this.$message.warning('上传失败！');
    },
    handleUploadLogoSuccess(res,file){//console.log(file);
      if(res&&res.data){
        this.org.logoPath=res.data;
        this.org.logoURL=downloadFileURL+"?filePath="+encodeURI(res.data)+"&accessToken="+encodeURI(store.getters.accessToken);
      }else this.$message.warning('上传失败！');
    },
    handleUploadLogoError(param){//console.log(param);
      this.$message.warning('上传失败！');
    },
    path2Array(path){
      if(!path){return;}
      this.businessLicensePathArray=path.split(',');
      if(this.businessLicensePathArray.length>0){
        for(let i=0;i<this.businessLicensePathArray.length;i++){
          if(this.businessLicensePathArray[i]){
            this.businessLicensePathArrayTwo[i]=this.businessLicensePathArray[i];
            this.businessLicensePathArray[i]=downloadFileURL+"?filePath="+encodeURI(this.businessLicensePathArray[i])+"&accessToken="+encodeURI(store.getters.accessToken);
          }
        }
      }
    }
  }
})
</script>


<style lang="scss" scoped>
.busi-license-del {
  display: inline-block;
  position: absolute;
  color:red;
  margin-left: 10px;
  cursor:pointer;
}
</style>